import type { Stores } from "@repo/share-log-ui/context";
import { storeDeps } from "./deps";
import {
  createAuthStore,
  createWorkspaceStore,
  createLogStore,
  createAdjustmentStore,
  createCategoryStore,
  createMethodStore,
  createInvitationStore,
  createNotificationStore,
  createNotificationSettingStore,
  createSpendingGoalStore,
  createStatsStore,
  createAssetStore,
} from "@repo/share-log-stores";

export const useAuthStore = createAuthStore(storeDeps);
export const useWorkspaceStore = createWorkspaceStore(storeDeps);
export const useLogStore = createLogStore(storeDeps);
export const useAdjustmentStore = createAdjustmentStore(storeDeps);
export const useCategoryStore = createCategoryStore(storeDeps);
export const useMethodStore = createMethodStore(storeDeps);
export const useInvitationStore = createInvitationStore(storeDeps);
export const useNotificationStore = createNotificationStore(storeDeps);
export const useNotificationSettingStore = createNotificationSettingStore(storeDeps);
export const useSpendingGoalStore = createSpendingGoalStore(storeDeps);
export const useStatsStore = createStatsStore(storeDeps);
export const useAssetStore = createAssetStore(storeDeps);

/** 공유 UI(`@repo/share-log-ui`)에 주입하는 store. 위 인스턴스와 같은 싱글턴이다 */
export const appStores: Stores = {
  auth: useAuthStore,
  workspace: useWorkspaceStore,
  log: useLogStore,
  category: useCategoryStore,
  method: useMethodStore,
  stats: useStatsStore,
};

export type {
  AuthStore,
  WorkspaceStore,
  LogStore,
  AdjustmentStore,
  CategoryStore,
  MethodStore,
  InvitationStore,
  NotificationStore,
  NotificationSettingStore,
  SpendingGoalStore,
  StatsStore,
  AssetStore,
} from "@repo/share-log-stores";
